<script>
import { Doughnut, mixins } from 'vue-chartjs'

export default {
  extends: Doughnut,
  mixins: [mixins.reactiveProp],
  props: ['options'],
  mounted () {
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    chartData () {
      this.$data._chart.update()
    },
    options () {
      this.$data._chart.update()
    }
  },
  methods: {
    getChartSettings () {
      const boolOpts = [{label: 'Yes', value: true}, {label: 'No', value: false}]
      const chartSettings = [
        {
          title: "Chart settings",
          classes: 'grid colours',
          fields: [
            {type: 'number', label: 'Cutout %', name: 'cutoutPercentage', model: 'cutoutPercentage'},
          ]
        }
      ]

      const datasetSettings = [
        {
          title: "Dataset settings",
          classes: 'grid colours',
          fields: [
            {type: 'color', label: 'Line colour', name: 'borderColor', model: 'borderColor'},
          ]
        }
      ]

      return {chart: chartSettings, dataset: datasetSettings}
    }
  }
}
</script>

<style>
</style>